import moment from 'moment';
import Vue from 'vue';

export default {
  state: {
    projects: {},
    projectForks: {},
    repositoryLabels: {},
    referenceUsers: {},
    referenceTeamUsers: {},
    referenceCompanyUsers: {},
    referenceTeams: {},
    issueReferenceUsers: {},
    issueStatuses: [],
    branches: [],
    sastEnabled: false,
    cicdEnabled: false,
    actionAvailablityMap: {},
    mrApproversEnabled: false,
    branchPermissions: {}
  },
  mutations: {
    setProjectsRef(state, payload) {
      state.projects = payload;
    },
    setRepoLabels(state, payload) {
      state.repositoryLabels = { ...payload };
    },
    setReferenceUsers(state, payload) {
      state.referenceUsers = { ...payload };
    },
    setReferenceTeamUsers(state, payload) {
      state.referenceTeamUsers = { ...payload };
    },
    setReferenceCompanyUsers(state, payload) {
      state.referenceCompanyUsers = { ...payload };
    },
    setReferenceTeams(state, payload) {
      state.referenceTeams = { ...payload };
    },
    setIssuesRefUsers(state, payload) {
      state.issueReferenceUsers = { ...payload };
    },
    setRefBranches(state, payload) {
      state.branches = { ...payload };
    },
    setIssueStatuses(state, payload) {
      state.issueStatuses = [...payload];
    },
    setForksRef(state, payload) {
      state.projectForks = { ...payload };
    },
    setSastStatus(state, payload) {
      state.sastEnabled = payload;
    },
    setCicdStatus(state, payload) {
      state.cicdEnabled = payload;
    },
    setMrApproversStatus(state, payload) {
      state.cicdEnabled = payload;
    },
    addBranchPermissions(state, payload) {
      Vue.set(state.branchPermissions, payload?.branch, payload?.permissions);
    }
  },
  actions: {
    setProjectsRef(state, payload) {
      state.commit('setProjectsRef', payload);
    },
    setRefRepoLabels(state, payload) {
      state.commit('setRepoLabels', payload);
    },
    setReferenceUsers(state, payload) {
      state.commit('setReferenceUsers', payload);
    },
    setReferenceTeamUsers(state, payload) {
      state.commit('setReferenceTeamUsers', payload);
    },
    setReferenceCompanyUsers(state, payload) {
      state.commit('setReferenceCompanyUsers', payload);
    },
    setReferenceTeams(state, payload) {
      state.commit('setReferenceTeams', payload);
    },
    setIssuesRefUsers(state, payload) {
      state.commit('setIssuesRefUsers', payload);
    },
    setRefBranches(state, payload) {
      state.commit('setRefBranches', payload);
    },
    setIssueStatuses(state, payload) {
      state.commit('setIssueStatuses', payload);
    },
    setForksRef(state, payload) {
      state.commit('setForksRef', payload);
    },
    setSastStatus(state, payload) {
      state.commit('setSastStatus', payload);
    },
    setCicdStatus(state, payload) {
      state.commit('setCicdStatus', payload);
    },
    setMrApprovers(state, payload) {
      state.commit('setMrApproversStatus', payload);
    },
    addBranchPermissions(state, payload) {
      state.commit('addBranchPermissions', payload);
    }
  },
  getters: {
    getProjectsRef(state) {
      return state.projects;
    },
    getRepoLabels(state) {
      return state.repositoryLabels;
    },
    getReferenceUsers(state) {
      return state.referenceUsers;
    },
    getReferenceTeamUsers(state) {
      return state.referenceTeamUsers;
    },
    getReferenceCompanyUsers(state) {
      return state.referenceCompanyUsers;
    },
    getReferenceTeams(state) {
      return state.referenceTeams;
    },
    getIssuesRefUsers(state) {
      return state.issueReferenceUsers;
    },
    getRefBranches(state) {
      return state.branches;
    },
    getRefIssueStatus(state) {
      return state.issueStatuses;
    },
    getRefProjectForks(state) {
      return state.projectForks;
    },
    getSastStatus(state) {
      return state.sastEnabled;
    },
    getCicdStatus(state) {
      return state.cicdEnabled;
    },
    getMrApprovers(state) {
      return state.mrApproversEnabled;
    },
    getActionAvailabilityFlag: (state) => (action) => {
      const storedFlag = state.actionAvailablityMap[action];
      if (storedFlag != null) {
        // console.debug("доступность", action, "сохранена и равна", storedFlag)
        return storedFlag;
      }

      const element = document.getElementById(action);
      if (!element) {
        // console.error("для доступа", action, "не указана его доступность");
        return false;
      }
      const flag = element?.value === 'true';
      // console.debug("действие", action, "доступно:", flag)
      state.actionAvailablityMap[action] = flag;
      return flag || false;
    },
    getBranchPermissionByBranch: (state) => (branchName) =>
      state.branchPermissions[branchName] || null
  }
};
